var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFocus = function SvgFocus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Focus",
    clipPath: "url(#clip0_37628_6322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4093 3.15888C20.0692 2.47062 21.689 4.14375 21.0416 5.77208L21.0381 5.78069L14.8846 20.4592L14.8837 20.4612C14.1853 22.1174 11.8126 22.0851 11.1688 20.4011C11.1685 20.4003 11.1681 20.3994 11.1678 20.3986L9.11019 15.0747L3.77259 13.0057C3.77243 13.0056 3.77275 13.0057 3.77259 13.0057C2.09574 12.3587 2.07253 9.9975 3.72377 9.30119L3.72646 9.30006L18.4065 3.16006L18.4093 3.15888ZM19.1726 5.00749L4.5022 11.1435L9.8313 13.2093C9.83177 13.2095 9.83223 13.2096 9.8327 13.2098C10.3558 13.4115 10.7738 13.8295 10.9753 14.3527C10.9752 14.3524 10.9754 14.353 10.9753 14.3527L13.0358 19.6839C13.0363 19.684 13.0369 19.684 13.0375 19.684C13.0387 19.684 13.0399 19.684 13.041 19.6839L19.1846 5.02912C19.1853 5.027 19.1858 5.02535 19.1861 5.02415C19.1858 5.02355 19.1854 5.02282 19.185 5.02196C19.1831 5.01871 19.1803 5.01478 19.1765 5.01097C19.1751 5.00964 19.1738 5.00849 19.1726 5.00749Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37628_6322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFocus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Focus.88e0884a164f47b3b4c4d3ceaf6dc451.svg";